module.exports = __webpack_public_path__ + "img/no_data.c9f2b0ef.png";